import React from "react";
import { IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const BackButton = ({ 
  onClick, 
  sx = {},
  color = "inherit",
  size = "medium",
  ...props 
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      // Default behavior: go back in history
      navigate(-1);
    }
  };

  return (
    <IconButton
      onClick={handleClick}
      color={color}
      size={size}
      sx={{
        position: "absolute",
        top: 16,
        left: 16,
        zIndex: 1,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        "&:hover": {
          backgroundColor: "rgba(255, 255, 255, 1)",
        },
        // boxShadow: 1,
        ...sx,
      }}
      {...props}
    >
      <ArrowBack />
    </IconButton>
  );
};

export default BackButton;